import { makeStyles } from '@material-ui/core/styles'
import { createStyles, Theme } from '@material-ui/core'

export const useCheckoutSummaryStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      textAlign: 'left',
      '& > .MuiBox-root': {
        height: '100%',
      },
    },

    totalPrice: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: theme.spacing(2),
    },

    totalPriceLabel: {
      fontWeight: 'bold',
    },

    totalPriceAmount: {
      fontSize: '1.2rem',
      color: theme.palette.primary.main,
      fontWeight: 'bold',
    },

    priceAmount: {
      fontWeight: 'bold',
    },

    summaryItem: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: theme.spacing(1),
    },

    summaryItemLabel: {
      fontWeight: 600,
    },

    summaryItemValue: {
      fontWeight: 'bold',
      marginLeft: theme.spacing(2),
      textAlign: 'right',
    },
  })
)
